import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import ReturnSuccess from "../components/ReturnSuccess";
import { CartProvider } from "../../cart/context/CartContext";
const ReturnSuccessPage = () => {
  return (
    <CartProvider>
      <ColorInit color={"bigmall"} />
      <ScrollToTop smooth color="#ef253c" />
      <Header />
      <ReturnSuccess />
      <Footer />
      <BottomFooter />
    </CartProvider>
  );
};

export default ReturnSuccessPage;
